import { EmailSubscriptionFormComponent } from "./component"
customElements.define("scattergun-subscription-form", EmailSubscriptionFormComponent)